/* Shared utilities. Prices and checkout are always owned by Shopify. */
(() => {
  window.BirdyTheme = window.BirdyTheme || {};
  window.BirdyTheme.money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:window.BirdyTheme.currency || 'USD'}).format(Number(cents) / 100);
  document.addEventListener('birdy:cart-updated', event => {
    const count = event.detail?.item_count;
    if (!Number.isInteger(count)) return;
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = String(count); });
  });
})();
